module.exports = __webpack_public_path__ + "img/Security.8452215d.png";